<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img class="w-7 h-7 rounded-full" alt="avatar" *ngIf="showAvatar && user.photo" [src]="user.photo">
        <mat-icon *ngIf="!showAvatar || !user.photo"  [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{'signed-in-as' | transloco}}</span>
            <span class="mt-1.5 text-md font-medium">{{user?.email || 'agritrack@email.com'}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button  mat-menu-item (click)="goToProfile()">
        <span class="flex flex-col leading-none">
            <div class="inline-flex">
                <mat-icon [svgIcon]="'heroicons_outline:identification'"></mat-icon>
                <span class="pt-1">{{'profile-button' | transloco}}</span>
            </div>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>{{'sign-out' | transloco}}</span>
    </button>
</mat-menu>